import { getDataAPI, postDataAPI } from "../../../services/apiWrapper";

/*
  NOC, student side.

  The student picks a NOC type the council offers and a validity (3 or 6
  months), pays the fee, and the NOC is issued automatically. apply/paySuccess
  return the server's full { status, data, message } so the screen can branch on
  rejected / free / paid; the Razorpay step lives in utils/nocPay.
*/

const token = () => localStorage.getItem("studentToken");

export const getNocTypes = () => async (dispatch) => {
  try {
    const response = await dispatch(getDataAPI("student/noc/types", token()));
    return {
      types: response.data.data || [],
      eligibility: response.data.eligibility || null,
    };
  } catch (error) {
    return { types: [], eligibility: null };
  }
};

export const getMyNoc = () => async (dispatch) => {
  try {
    const response = await dispatch(getDataAPI("student/noc/list", token()));
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

export const applyNoc = (body) => async (dispatch) => {
  try {
    const response = await dispatch(postDataAPI("student/noc/apply", body, token()));
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failed",
        message: "The request could not be sent. Please try again.",
      }
    );
  }
};

export const payNocSuccess = (body) => async (dispatch) => {
  try {
    const response = await dispatch(
      postDataAPI("student/noc/pay-success", body, token())
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failed",
        message: "Payment could not be verified.",
      }
    );
  }
};
